import {
  Box,
  Flex,
  Image,
  Text,
  Grid,
  useMediaQuery,
  Heading,
} from '@chakra-ui/react';
import Wrapper from '../../../common/Wrapper';
import { phoneFrame } from '../../../../assets/exports';
import { bizflexUsage } from '../../../common/constants';
import { FaArrowRight } from 'react-icons/fa';
import { GiPlainCircle } from 'react-icons/gi';

const EightLayer = () => {
  const [isMobile] = useMediaQuery('(max-width: 501px)');

  return (
    <Wrapper>
      <Flex
        flexDir="column"
        justifyContent="center"
        minH="100vh"
        pt={isMobile ? '99px' : '137px'}
        bgGradient="linear(to-r, #F9F3ED,#F2ECF8)"
      >
        <Box mx="auto">
          <Image src={phoneFrame} />
        </Box>
        <Heading
          pt="40px"
          textAlign="center"
          pb={{ base: '46px', md: '76px' }}
          fontSize={['32px', '32px', '48px', '54px']}
        >
          Who Can Use BizFlex?{' '}
        </Heading>
        <Grid
          mb="20px"
          w="100%"
          align="center"
          gap="27px"
          placeItems="center"
          px={['20px', '20px', '50px', '110px']}
          gridTemplateColumns={{ base: '1fr', md: 'repeat(3,1fr)' }}
        >
          {bizflexUsage?.map((data, i) => {
            return (
              <Box
                borderRadius="25px"
                h="full"
                px="24px"
                key={i}
                bg={i === 1 ? '#F3C948' : '#0F172B'}
                bgGradient={i === 1 && 'linear(to-b, #FF9D16, #543202)'}
                color="#fff"
                py={{ base: '24px', md: '2rem' }}
              >
                <Box>
                  <Image mx="auto" w="80x" h="80px" src={data.img} />
                </Box>
                <Text
                  pt="1rem"
                  lineHeight="1.2"
                  fontWeight={700}
                  fontSize="2rem"
                >
                  {data.title}
                </Text>
                <Text pt="5px">{data.sub}</Text>

                <Flex flexDir="column" gap="10px" pt="23px">
                  {data?.points?.map((item) => (
                    <Text
                      display="flex"
                      gap="6px"
                      alignItems="center"
                      textAlign="left"
                    >
                      <GiPlainCircle />
                      {item}
                    </Text>
                  ))}
                </Flex>
                <Flex
                  w="fit-content"
                  cursor="pointer"
                  mx="auto"
                  justifyContent="center"
                  alignItems="center"
                  gap="5px"
                  pt="2rem"
                >
                  <Text>Learn More</Text>
                  <FaArrowRight />
                </Flex>
              </Box>
            );
          })}
        </Grid>
      </Flex>
    </Wrapper>
  );
};
export default EightLayer;
